<template>
    <div class="game-tag-info">
        <span class="hidden-xs-only">
            <el-tag v-if="game.status.labels[0] === 'going2play'" type="warning" size="mini">Going to play</el-tag>
            <el-tag v-if="game.status.labels[0] === 'playing'" size="mini">playing</el-tag>
            <el-tag v-if="game.status.labels[0] === 'paused'" type="warning" size="mini">Paused</el-tag>
            <el-tag v-if="game.status.labels[0] === 'played'" type="warning" size="mini">Played</el-tag>
            <el-tag v-if="game.status.labels[0] === 'finished'" type="success" size="mini">Finished</el-tag>
            <el-tag v-if="game.status.labels[0] === 'none'" type="warning" size="mini">No status</el-tag>

            <span><i v-if="addGameEnabled && !game.inMyGames && !game.updatingStatus" @click="addStatus(game)" class="el-icon-circle-plus clickable add-game"></i></span>
            <span><i v-if="addGameEnabled && game.updatingStatus" style="color: gray;" class="el-icon-loading"></i></span>
        </span>

        <span class="hidden-sm-and-up">
            <el-tag v-if="game.status.labels[0] === 'going2play'" type="warning" size="mini" class="game-status"><i class="el-icon-circle-plus"></i></el-tag>
            <el-tag v-if="game.status.labels[0] === 'playing'" size="mini" class="game-status"><i class="el-icon-caret-right"></i></el-tag>
            <el-tag v-if="game.status.labels[0] === 'paused'" type="warning" size="mini" class="game-status"><i class="el-icon-video-pause"></i></el-tag>
            <el-tag v-if="game.status.labels[0] === 'played'" type="warning" size="mini" class="game-status"><i class="el-icon-remove"></i></el-tag>
            <el-tag v-if="game.status.labels[0] === 'finished'" type="success" size="mini" class="game-status"><i class="el-icon-success"></i></el-tag>
            <el-tag v-if="game.status.labels[0] === 'none'" type="warning" size="mini" class="game-status"><i class="el-icon-bell"></i></el-tag>

            <span><i v-if="addGameEnabled && !game.inMyGames && !game.updatingStatus" @click="addStatus(game)" class="el-icon-circle-plus clickable add-game"></i></span>
            <span><i v-if="addGameEnabled && game.updatingStatus" style="color: gray;" class="el-icon-loading"></i></span>
        </span>
    </div>
</template>

<script>
export default {
  name: 'gameTagInfo',
  components: {},
  props: ['game', 'addGameEnabled', 'addStatus'],
  mounted () {
  },
  data () {
    return {
    }
  },

  methods: {

  }
}
</script>

<style lang="scss">
@import '../styles/variables.scss';

.game-tag-info {
    .tag-style-played::before{
        color: orange;
    }
    .tag-style-finished::before{
        color: green;
    }
    .tag-style-paused::before{
        color: purple;
    }
    .tag-style-playing::before{
        color: blue;
    }
    .tag-style-none::before{
        color: gray;
    }
    .tag-style-going2play::before{
        color: orange;
    }

    .el-tag.el-tag--info.el-tag--small.el-tag--light {
        width: 25px;
        margin-left: 25px !important;
    }

    .add-game {
        color: $main-color-2;
        margin-right: -16px;
    }

    @media screen and (max-width: 35em) {
        .game-status {
            margin-right: -10px;
        }

        .add-game {
            position: absolute;
            margin-top: 4px;
            margin-left: 10px;
        }
    }
}
</style>
